<template>
  <div class="message-link" :class="{ 'message-link--clickable': linkUrl }" @click="handleOpenLink">
    <div v-if="linkUrl" class="message-link__header">
      <img alt="" class="message-link__icon" :src="crmIcon" />
      <div class="message-link__url">{{ linkUrl }}</div>
      <button class="message-link__copy" type="button" @click.stop="handleCopyLink">
        <i class="icon-file-copy-line t-iconfont"></i>
      </button>
    </div>
    <div class="message-link__title">{{ title }}</div>
    <div class="message-link__url">{{ linkUrl }}</div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { ElMessage } from 'element-plus'
import utils from '@/utils'

const props = defineProps({
  message: {
    type: Object,
    default: () => ({
      title: '',
      url: ''
    })
  }
})

const crmIcon = require('@/assets/html-fill.svg')

const title = computed(() => props.message.title || '')
const linkUrl = computed(() => props.message.url || '')

const handleOpenLink = () => {
  if (!linkUrl.value) return

  window.open(linkUrl.value, '_blank', 'noopener,noreferrer')
}

const handleCopyLink = () => {
  if (!linkUrl.value) return

  utils.copyToClipboard(
    linkUrl.value,
    () => {
      ElMessage.success('复制成功')
    },
    () => {
      ElMessage.error('复制失败')
    }
  )
}
</script>

<style lang="scss" scoped>
.message-link {
  display: block;
  width: 240px;
  padding: 12px;
  color: #323233;
  text-decoration: none;
  background: #fff;
  border: 1px solid #f2f3f5;
  border-radius: 8px;
}

.message-link--clickable {
  cursor: pointer;
}

.message-link__header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.message-link__icon {
  flex: none;
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.message-link__url {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  font-size: 12px;
  line-height: 20px;
  color: #969799;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.message-link__copy {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  color: #969799;
  cursor: pointer;
  background: transparent;
  border: 0;
}

.message-link__copy .t-iconfont {
  font-size: 16px;
  line-height: 16px;
}

.message-link__title {
  overflow: hidden;
  font-size: 14px;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
